export default "__VITE_ASSET__Cyxw_Her__"